import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/style/index.less";

import "ant-design-vue/dist/antd.css";

import antd from "ant-design-vue";

// import "@/config/remconfig"
// import "amfe-flexible/index.js";
Vue.config.productionTip = false;
Vue.use(antd);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
